export default {
  "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["hello i18n !!"])},
  "Google": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Google"])}
}